import QueryString from 'qs';
import {
  getV3,
  internalGet,
  internalPatch,
  internalPost,
  unwrapListEnvelope,
} from './index';

export const getToConnectionRequests = ({ filters = {} } = {}) =>
  getV3(
    // Renamed from to-connection-requests: the v3 resource is `connections`.
    `connections?${QueryString.stringify({
      perPage: 1000,
      ...filters,
    })}`,
  ).then(unwrapListEnvelope);

// Walks every page of the v3 list: a single page caps at 1000 rows, which
// silently drops connections once a scope grows past it.
export const getAllToConnectionRequests = async ({ filters = {} } = {}) => {
  const firstPage = await getToConnectionRequests({ filters });
  const lastPage = Math.max(1, firstPage?.meta?.lastPage ?? 1);

  const otherPages = await Promise.all(
    Array.from({ length: lastPage - 1 }, (_, index) =>
      getToConnectionRequests({ filters: { ...filters, page: index + 2 } }),
    ),
  );

  return {
    ...firstPage,
    data: [
      ...(firstPage?.data ?? []),
      ...otherPages.flatMap((page) => page?.data ?? []),
    ],
  };
};

export const getToConnectionRequestById = async ({ requestId, dmcId }) => {
  return internalGet(`/to-connection-requests/${requestId}?dmcId=${dmcId}`);
};

export const getOrganizationByToDmc = ({
  toOrganizationId,
  dmcOrganizationId,
  kind,
}) =>
  internalGet(
    `to-connection-requests/${dmcOrganizationId}/${toOrganizationId}?kind=${kind}`,
  );

export const updateToConnectionRequest = ({
  toConnectionRequestId,
  payload,
}) => {
  return internalPatch(
    `/to-connection-requests/${toConnectionRequestId}`,
    payload,
  );
};

export const updateManyToConnectionRequest = (payload) => {
  return internalPatch(`/to-connection-requests/bulk`, payload);
};

// Dry run of the distribution guard: lists the products of the distributed
// templates that the targeted TOs cannot see. Same payload shape as the bulk
// endpoint, so a single-TO distribution just sends a one-element array.
export const checkToConnectionRequestDistribution = (payload) => {
  return internalPost('/to-connection-requests/distribution-check', payload);
};
